module.exports = __webpack_public_path__ + "mc.svg?2f6d3e1b896b9d4e414c2b830c1d95e5";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/mc.svg
// module id = 1120
// module chunks = 27